// import Vue from 'vue'
import throttle from 'lodash/throttle'

export const MyFixedTitle = {
  inserted: (el) => {
    const sibling = el.parentNode.lastChild
    let pad

    el.setPad = throttle(() => {
      pad = el.clientHeight
      sibling.style.paddingTop = pad + 'px'
    }, 300)

    setTimeout(() => {
      el.setPad()
    })
    window.addEventListener('resize', el.setPad)
  },
  unbind: (el) => {
    if (el.setPad) {
      window.removeEventListener('resize', el.setPad)
      el.setPad = undefined
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/my-fixed-title.js